/**
 * useSafeBackNavigation Hook
 * 
 * Simple and deterministic back navigation using location.state.from
 * 
 * Usage:
 *   const handleBack = useSafeBackNavigation('/training');
 *   <Button onClick={handleBack}>← Retour</Button>
 * 
 * Behavior:
 *   - If location.state.from exists: navigates to that route
 *   - Otherwise: navigates to fallbackPath
 * 
 * Convention:
 *   When navigating TO a page that needs back navigation:
 *   navigate('/target', { state: { from: location.pathname } })
 * 
 * @param {string} fallbackPath - Default route when no 'from' state (default: '/training')
 * @returns {Function} Navigation handler function
 */

import { useNavigate, useLocation } from 'react-router-dom';

export const useSafeBackNavigation = (fallbackPath = '/training') => {
  const navigate = useNavigate();
  const location = useLocation();
  
  return () => {
    // Read the 'from' path from location state
    const fromPath = location.state?.from;
    
    console.log('[useSafeBackNavigation] Current location.state:', location.state);
    console.log('[useSafeBackNavigation] from:', fromPath);
    console.log('[useSafeBackNavigation] fallback:', fallbackPath);
    
    // Navigate to 'from' if available, otherwise fallback
    const targetPath = fromPath || fallbackPath;
    
    console.log('[useSafeBackNavigation] Navigating to:', targetPath);
    navigate(targetPath, { replace: true });
  };
};

export default useSafeBackNavigation;
